<template>
  <v-container class="text-right">
    <v-row class="text-left">
      <v-col
        cols="6">
        <label class="font-weight-bold font-readex">Vyberte jídelníček</label>
        <v-select
          :items="diets"
          outlined
          item-text="name"
          return-object
          disable-lookup
          class="rounded-lg"
          v-model="cart.diet"
          :disabled="stepConfirmed || dietLoading"
          @change="checkStep"
          :loading="dietLoading"
          color="darkGreen"
          hide-details
        ></v-select>
      </v-col>
      <v-col
        cols="6"
        v-if="!!Object.keys(cart.diet).length">
        <label class="font-weight-bold font-readex">Vyberte uživatele</label>
        <v-select
          color="darkGreen"
          class="rounded-lg"
          v-model="cart.order"
          :items="user"
          hide-details
          item-text="fullName"
          return-object
          hide-selected
          persistent-hint
          deletable-chips
          small-chips
          disable-lookup
          style="color: #979797"
          outlined
          @change="checkStep"
          :disabled="stepConfirmed"
        ></v-select>
      </v-col>
      <v-col
        cols="6"
        v-if="!!Object.keys(cart.diet).length">
      </v-col>
      <v-col
        cols="6"
        v-if="!!Object.keys(cart.diet).length && cart.boarders !== []">
        <label class="font-weight-bold font-readex">Vyberte strávníky</label>
        <v-select
          color="darkGreen"
          @change="checkStep"
          class="rounded-lg"
          v-model="cart.boarders"
          :items="boarders"
          item-text="fullName"
          return-object
          hide-selected
          hide-details
          style="color: #979797"
          multiple
          persistent-hint
          small-chips
          deletable-chips
          outlined
          disable-lookup
          :disabled="stepConfirmed"
        ></v-select>
      </v-col>
    </v-row>
    <v-btn
      class="btn btn-green-gradient"
      :disabled="!stepValid"
      v-if="!stepConfirmed"
      dark
      @click="confirmStep"
    >
      Potvrdit
    </v-btn>
    <v-btn
      class="btn btn-red-gradient"
      v-if="stepConfirmed"
      dark
      @click="cancelOrder"
    >
      Zrušit objednávku
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'NewStep1',
  data () {
    return {
      availableBoarders: [],
      availableDiets: [],
      stepValid: false,
      stepConfirmed: false,
      dietLoading: false
    }
  },
  methods: {
    nextStep () {
      const tmpUser = Object.assign({}, this.currentUser)
      delete tmpUser.accessToken
      this.setUser(tmpUser)
    },
    checkStep () {
      this.stepValid = !!(this.cart.diet.id && (this.cart.order || this.cart.boarders.length))
    },
    confirmStep () {
      this.nextStep()
      this.stepConfirmed = true
      this.$emit('stepConfirmed')
      this.goToStep(3)
    },
    initialize () {
      this.dietLoading = true
      this.$http.get(`/admin/user/${this.currentUser.id}/boarders`)
        .then(response => {
          this.availableBoarders = this.keysToCamelCase(response.data)
            .map(boarder => {
              boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
              return boarder
            }).filter(boarder => boarder.active)
        })
        .catch(err => console.log(err))
      this.$http.get('/diets')
        .then(response => {
          this.availableDiets = this.keysToCamelCase(response.data)
            .filter(diet => {
              if (!diet.active) {
                return false
              }
              return !(diet.dietType === 'Instituční' && !diet.institutionId)
            })
          this.dietLoading = false
        })
        .catch(err => console.log(err))
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
        .catch(err => {
          console.log(err)
        })
      const shoppingCartInfo = JSON.parse(localStorage.getItem('shoppingCart'))
      if (shoppingCartInfo) {
        this.shoppingCart = shoppingCartInfo
      }
    },
    cancelOrder () {
      this.reset()
      this.$emit('orderCanceled')
      this.stepConfirmed = false
    },
    ...mapMutations({
      reset: 'ordering/reset',
      goToStep: 'ordering/goToOrderingStep',
      setDeliveryInfo: 'ordering/setDeliveryInfo',
      setUser: 'ordering/setUser'
    })
  },
  computed: {
    diets () {
      const boarderDietIDs = this.availableBoarders.map(p => p.diets[0].id)
      const timeValid = this.availableDiets.filter(diet => {
        const tmpDate = new Date()
        const maxDietDate = new Date(diet.dateTo)
        return tmpDate.getTime() <= maxDietDate.getTime()
      })
      const filtered = timeValid
        .filter(diet => {
          const publiclyAvailable = diet.dietType === 'Veřejný' || diet.dietType === 'Stálá nabídka'
          const boarderDiet = boarderDietIDs.includes(diet.id)
          const userInstitution = diet.institutionId === this.currentUser.institutionId

          return publiclyAvailable || boarderDiet || userInstitution
        })
      return filtered
    },
    user () {
      if (this.cart.boarders.length) { // objednavka nemuze byt pro usera i stravniky
        return []
      }

      if (!this.cart.diet.id || this.cart.diet.dietType !== 'Instituční') {
        return [this.currentUser]
      }

      if (this.cart.diet.dietType === 'Instituční' &&
        this.cart.diet.institutionId === this.currentUser.institutionId) {
        return [this.currentUser]
      } else {
        return []
      }
    },
    boarders () {
      if (!this.cart.diet.id) {
        return this.availableBoarders
      } else {
        return this.availableBoarders.filter(boarder => boarder.diets[0].id === this.cart.diet.id)
      }
    },
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart'
    }),
    // vuex bindings
    'cart.diet': {
      get () {
        return this.$store.ordering.state.cart.diet
      },
      set (diet) {
        this.$store.ordering.state.cart.diet = diet
      }
    },
    'cart.order': {
      get () {
        return this.$store.ordering.state.cart.order
      },
      set (user) {
        this.$store.ordering.state.cart.order = !!user
      }
    },
    'cart.boarders': {
      get () {
        return this.$store.ordering.state.cart.boarders
      },
      set (boarders) {
        this.$store.ordering.state.cart.boarders = boarders
      }
    }
  },
  watch: {
    'cart.diet': function (diet) {
      if (!diet.id) {
        return
      }
      const options = {
        method: 'post',
        url: '/orders-info',
        data: this.keysToSnakeCase({
          userId: this.currentUser.id,
          dietId: this.cart.diet.id
        })
      }
      this.$http(options)
        .then(response => {
          const data = this.keysToCamelCase(response.data)
          this.setDeliveryInfo(data)
        })
        .catch(err => { console.log(err) })

      this.cart.boarders = this.cart.boarders.filter(boarder => boarder.diets[0].id === diet.id)
      // if user was selected and can order from diet, it stays in the cart
      this.cart.user = this.user.length && this.cart.user ? this.user[0] : null

      if (diet.dietType === 'Instituční') {
        this.cart.deliveryType = 'Rozvoz'
      } else {
        this.cart.deliveryType = this.currentUser.preferredDeliveryType
      }
    },
    'cart.boarders': function (boarders) {
      if (boarders.length) {
        this.cart.order = false
      }
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
